import { useCompletedInspectionsByTemplate } from 'charts/completedInspectionsByTemplate';
import { useInspectionEvolution } from 'charts/inspectionEvolution';
import { useInspectionTriplet } from 'charts/inspectionTriplet';
import { useMemo } from 'react';
import type { ChartFiltersUnion } from 'shared/types/analytics';
import type { ChartId } from '../../catalog/chartCatalog';
import type { ChartResult } from '../../catalog/types';
import type { CatalogInspectionChartId } from '../../constants/catalogInspectionCharts';
import { useCatalogChartBundle } from '../useCatalogChartBundle';
import type { ChartRuntime } from 'views/analytics/types';

export type InspectionChartRuntime = Readonly<{
  results: Readonly<Partial<Record<ChartId, ChartResult>>>;
  runtimeById: Readonly<
    Partial<
      Record<CatalogInspectionChartId, ChartRuntime<ChartFiltersUnion>>
    >
  >;
}>;

export function useInspectionChartResultsInternal(): InspectionChartRuntime {
  const completedInspectionsByTemplate = useCatalogChartBundle(
    'completedInspectionsByTemplate',
    useCompletedInspectionsByTemplate()
  );
  const inspectionEvolution = useCatalogChartBundle(
    'inspectionEvolution',
    useInspectionEvolution()
  );
  const inspectionTriplet = useCatalogChartBundle(
    'inspectionTriplet',
    useInspectionTriplet()
  );

  return useMemo(
    (): InspectionChartRuntime => ({
      results: {
        completedInspectionsByTemplate:
          completedInspectionsByTemplate.result,
        inspectionEvolution: inspectionEvolution.result,
        inspectionTriplet: inspectionTriplet.result,
      },
      runtimeById: {
        completedInspectionsByTemplate:
          completedInspectionsByTemplate.runtime,
        inspectionEvolution: inspectionEvolution.runtime,
        inspectionTriplet: inspectionTriplet.runtime,
      },
    }),
    [
      completedInspectionsByTemplate.result,
      completedInspectionsByTemplate.runtime,
      inspectionEvolution.result,
      inspectionEvolution.runtime,
      inspectionTriplet.result,
      inspectionTriplet.runtime,
    ]
  );
}
